import { SchemaRecord } from "../SchemaRecord.js";

export class ProfileGetOwnParams extends SchemaRecord {
  static type = "chat.params.profile_get_own";
  static schema = {};
}
